import PathfindingVisualizer from './PathfindingVisualizer/Node/PathfindingVisualizer';
import './App.css';

function App() {
  return (
    <div className="App">
      <PathfindingVisualizer />
    </div>
  );
}

export default App;
